import React, { useState, useEffect, Fragment } from 'react';
import Gallery from 'react-photo-gallery';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  CardImg,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_CONNECTWARE } from '../../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
let arr = [];
export default function ConnectWareSettings({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [connectionSettings, setConnectionSettings] = useState(
    integration?.phoneSuiteIntegration?.connectionSettings || {
      serviceProviderName: '',
      domain: '',
      serviceProviderLogo: '',
      sipGateway: '',
      originatingPhoneNumber: '',
      inboundTrunk: '',
      outboundTrunk: '',
    }
  );
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);
  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);
  }, [integrationProperties, allProperties]);

  const selectedImage = (image) => {
    setConnectionSettings({
      ...connectionSettings,
      serviceProviderLogo: image.src,
    });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleCheckChange = (e) => {
    // if (e.target.checked) {
    //   arr[e.target.id] = e.target.value;
    // }
    // if (!e.target.checked) {
    //   arr[e.target.id] = undefined;
    // }
    // const filterList = arr.filter(elem => elem !== undefined || null);
    // setList(filterList);

    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    const propertyArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    setList(propertyArr);
  };

  const handleSave = () => {
    if (connectionSettings.sipGateway === 'ConnectWare') {
      AxiosAPI({
        method: 'get',
        url: `${API_CONNECTWARE}/check-domain?domain=${connectionSettings?.domain}`,
      }).then((res) => {
        if (res.data.domain !== undefined && res.data.domain !== null) {
          saveIntegration({ connectionSettings: connectionSettings });
          arr = [];
          setList([]);
        } else {
          NotificationManager.error(
            '',
            'Domain is not correct.',
            3000,
            null,
            null,
            'error'
          );
        }
      });
    } else {
      saveIntegration({ connectionSettings: connectionSettings });
    }
  };

  const handleChangeServieProviderName = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      serviceProviderName: e.target.value,
    });
  };

  const handleChangeSIPGateway = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      sipGateway: e.target.value,
    });
  };

  const handleChangeDomain = (e) => {
    setConnectionSettings({ ...connectionSettings, domain: e.target.value });
  };

  const handleMymaChange = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      [e.target.name]: e.target.value,
    });
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            SIP Gateway Settings
            {/* <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            /> */}
          </h6>
        </div>
        <div className="text-center mb-2">
          <Separator className="mb-3" />
          <CardImg
            top
            src={connectionSettings?.serviceProviderLogo}
            alt="Card image cap"
            className="img-thumbnail border-0 rounded-circle list-thumbnail"
          />
        </div>
        <div className="text-center mb-3">
          <Button
            color="success"
            size="xs"
            className="mt-1"
            onClick={togglegallery}
          >
            Browse Service Provider Logo
          </Button>
        </div>
        <div className="text-left">
          <div className="mb-2">
            <h6>Select SIP Gateway</h6>
            <Input
              type="select"
              className="form-control"
              name="sipGateway"
              defaultValue={connectionSettings.sipGateway}
              onChange={handleChangeSIPGateway}
            >
              <option value={''}>Please Select</option>
              <option value={'ConnectWare'}>ConnectWare</option>
              <option value={'Myma.ai'}>Myma.ai</option>
            </Input>
          </div>

          <div className="mb-2">
            <h6>Service Provider Name</h6>
            <Input
              className="form-control"
              name="name"
              defaultValue={connectionSettings.serviceProviderName}
              onChange={handleChangeServieProviderName}
            />
          </div>
          {connectionSettings.sipGateway === 'ConnectWare' && (
            <div className="mb-2">
              <h6>Domain (from ConnectWare)</h6>
              <Input
                className="form-control"
                name="name"
                defaultValue={connectionSettings.domain}
                onChange={handleChangeDomain}
              />
            </div>
          )}
          {connectionSettings.sipGateway === 'Myma.ai' && (
            <Fragment>
              <div className="mb-2">
                <h6>Originating Phone Number</h6>
                <Input
                  className="form-control"
                  name="originatingPhoneNumber"
                  defaultValue={connectionSettings.originatingPhoneNumber}
                  onChange={handleMymaChange}
                />
              </div>
              <div className="mb-2">
                <h6>Inbound Trunk Name</h6>
                <Input
                  className="form-control"
                  name="inboundTrunk"
                  defaultValue={connectionSettings.inboundTrunk}
                  onChange={handleMymaChange}
                />
              </div>
              <div className="mb-2">
                <h6>Outbound Trunk Name</h6>
                <Input
                  className="form-control"
                  name="outboundTrunk"
                  defaultValue={connectionSettings.outboundTrunk}
                  onChange={handleMymaChange}
                />
              </div>
            </Fragment>
          )}
        </div>
        <div className="text-center">
          <ButtonGroup
            className="mb-2 text-center"
            style={{ marginTop: '20px' }}
          >
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="dark"
              outline
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </div>
        {ImageGalleryButton()}
      </CardBody>
    );
  };

  return <Card className="mb-4"> {Edit()}</Card>;
}
